var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "npb-voice-flash-call-container" }, [
    _vm.isSMSPanel
      ? _c("div", { staticClass: "npb-voice-flash-call-image__sms" })
      : _vm.isFlashCallPanel
      ? _c("div", { staticClass: "npb-voice-flash-call-image__flash" })
      : _vm.isVoiceCallPanel
      ? _c("div", { staticClass: "npb-voice-flash-call-image__voice" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "npb-voice-flash-call-content" }, [
      _vm.isSMSPanel
        ? _c("div", [
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__title" },
              [
                _c("i18n", {
                  attrs: { val: "second_step_thumbnail_sms_info_title" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__text" },
              [
                _c("i18n", {
                  attrs: { val: "second_step_thumbnail_sms_info_text" },
                }),
              ],
              1
            ),
          ])
        : _vm.isFlashCallPanel
        ? _c("div", [
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__title" },
              [
                _c("i18n", {
                  attrs: { val: "second_step_thumbnail_flash_call_info_title" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "npb-voice-flash-call-content__text" }, [
              _c(
                "span",
                [
                  _c("i18n", {
                    attrs: {
                      val: "second_step_thumbnail_flash_call_info_text_example",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "npb-voice-flash-call_content__text-phone npb-nowrap",
                },
                [
                  _c(
                    "span",
                    [
                      _c("i18n", {
                        attrs: {
                          val: "second_step_thumbnail_flash_call_info_text_phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "npb-voice-flash-call-content__text-circled",
                    },
                    [_vm._v("4359")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__text" },
              [
                _c("i18n", {
                  attrs: {
                    val: "second_step_thumbnail_flash_call_info_text_extend",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm.isVoiceCallPanel
        ? _c("div", [
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__title" },
              [
                _c("i18n", {
                  attrs: { val: "second_step_thumbnail_voice_call_info_title" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "npb-voice-flash-call-content__text" },
              [
                _c("i18n", {
                  attrs: { val: "second_step_thumbnail_voice_call_info_text" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }